var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBangaluru(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.147,
    height: 57.036,
    viewBox: "0 0 58.147 57.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11924",
    "data-name": "Group 11924",
    transform: "translate(-2575.343 282.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20397",
    "data-name": "Path 20397",
    d: "M2633.49-230.772v3.748a1.867,1.867,0,0,1-1.943,1.138q-27.13-.023-54.26,0a1.865,1.865,0,0,1-1.944-1.138v-3.748a1.722,1.722,0,0,1,2.049-1.13v-18.666a1.866,1.866,0,0,1-2.049-1.1v-6.36a1.831,1.831,0,0,1,2.041-1.053v-5.4c-1.328-.121-1.5-.219-2.041-1.157v-5.678a1.834,1.834,0,0,0,.1-.258,4.192,4.192,0,0,1,2.842-3.131q10.542-3.674,21.091-7.327a14.214,14.214,0,0,1,8.268-.486c2.1.532,4.141,1.3,6.194,2.012,5.536,1.909,11.063,3.844,16.6,5.761a4.04,4.04,0,0,1,2.246,1.638,14.435,14.435,0,0,1,.8,1.792v5.678a1.819,1.819,0,0,1-2.029,1.122v5.395c1.371.137,1.406.156,2.029,1.092v6.36a1.882,1.882,0,0,1-2.084,1.1v.72q0,7.178,0,14.356c0,.856-.288,1.281-.861,1.281s-.842-.411-.843-1.285q0-7.178,0-14.357v-.678h-3.375v18.619h.642c1.532,0,3.065.031,4.6-.011A1.779,1.779,0,0,1,2633.49-230.772Zm-54.332-28.307h7.087a3.7,3.7,0,0,1,.567.018.758.758,0,0,1,.69.714.758.758,0,0,1-.54.886,2.434,2.434,0,0,1-.727.081q-4.23.008-8.459,0h-.729v1.716h54.707v-1.716H2631q-19.871,0-39.741,0a3.181,3.181,0,0,1-.787-.064.759.759,0,0,1-.6-.9.758.758,0,0,1,.742-.723,6.12,6.12,0,0,1,.624-.013h38.424v-5.4h-50.5Zm-2.084-7.182h54.683V-269.6h-54.683Zm40.154,34.344c0-.635,0-1.181,0-1.728,0-1.121-.331-1.447-1.459-1.447H2593.06c-.132,0-.265,0-.4,0a.977.977,0,0,0-1.017.882c-.055.745-.014,1.5-.014,2.29h14.977a4.781,4.781,0,0,1,.567.01.787.787,0,0,1,.767.768.8.8,0,0,1-.686.9,2.741,2.741,0,0,1-.622.025H2587.3v2.575h34.221v-2.575H2611.6a3.57,3.57,0,0,1-.567-.011.829.829,0,0,1-.766-.844.806.806,0,0,1,.82-.837c.87-.024,1.741-.01,2.611-.011Zm-40.069-39.414c1.684,0,3.292,0,4.9-.005a1.933,1.933,0,0,0,.552-.111c6.186-1.929,12.375-3.847,18.553-5.8a10.359,10.359,0,0,1,6.359-.05c5.1,1.59,10.229,3.121,15.3,4.809a19.066,19.066,0,0,0,7.658,1.162c.382-.031.768,0,1.194,0a2.775,2.775,0,0,0-1.988-1.881q-10.308-3.569-20.61-7.159a13.81,13.81,0,0,0-9.445.049c-3.63,1.294-7.28,2.531-10.92,3.795q-4.9,1.7-9.8,3.4A2.571,2.571,0,0,0,2577.159-271.331Zm21.646,17.455c0,.39-.019.746,0,1.1.079,1.265-.332,2.19-1.966,2.235-.029,0-.057.042-.083.062v13.642h2.088v-.432c0-2.119-.023-4.238.013-6.357a6.706,6.706,0,0,1,.3-1.947,5.522,5.522,0,0,1,6.206-3.709,5.556,5.556,0,0,1,4.613,5.4c.026,2.157.007,4.313.009,6.47v.582h2.1v-13.691a2.09,2.09,0,0,0-.236-.051c-1.351-.126-1.837-.651-1.841-2,0-.429,0-.858,0-1.348h-3.462c-1.228,0-1.228,0-1.278,1.217-.025.627-.337,1-.837,1.014-.516.01-.848-.384-.864-1.042-.009-.373,0-.747,0-1.153Zm25.742,21.935v-21.927h-3.558c0,.42,0,.8,0,1.174,0,1.52-.413,1.979-1.929,2.148-.031,0-.058.038-.088.059v18.546Zm-40.25-21.939v21.935h5.559v-18.585c-1.634-.183-2.02-.616-2.02-2.223v-1.126Zm36.312-17.464a3.855,3.855,0,0,0-.419-.2c-4.453-1.395-8.9-2.8-13.362-4.173a8.048,8.048,0,0,0-4.861.016q-6.222,1.939-12.442,3.884c-.4.126-.8.254-1.2.381l.029.1ZM2582.5-231.937v-18.6h-3.327v18.6Zm9.132-4.834h3.34v-13.746h-3.34Zm22.2.018h3.353v-13.77h-3.353Zm-10.315-.061v-10.738a5.556,5.556,0,0,0-.633.209,3.722,3.722,0,0,0-2.328,3.464c-.042,2.229-.012,4.459-.01,6.689a2.875,2.875,0,0,0,.05.377Zm1.776-.023h2.966c0-2.477,0-4.912,0-7.347a2.532,2.532,0,0,0-.112-.612,3.616,3.616,0,0,0-2.849-2.679Zm-19.772,9.223v-2.561h-8.435v2.561Zm46.226-.013v-2.553h-8.445v2.553Zm-34.69-26.251h-7.5v1.565h7.5Zm22.2.006h-7.511v1.558h7.511Zm-42.178,0v1.568h5.421v-1.568Zm49.245,1.558h5.42v-1.559h-5.42Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20398",
    "data-name": "Path 20398",
    d: "M2588.7-155.708v-5.4h50.5v5.4h-38.424a6.119,6.119,0,0,0-.624.013.758.758,0,0,0-.741.723.759.759,0,0,0,.6.9,3.181,3.181,0,0,0,.787.064q19.871,0,39.741,0h.758v1.716h-54.707V-154h.729q4.229,0,8.459,0a2.432,2.432,0,0,0,.727-.081.757.757,0,0,0,.54-.886.758.758,0,0,0-.69-.714,3.7,3.7,0,0,0-.567-.018H2588.7Zm25.22-1.789h7.092c.151,0,.3.008.453,0a.842.842,0,0,0,.829-.837.84.84,0,0,0-.809-.856,3.358,3.358,0,0,0-.34-.006H2606.8a2.706,2.706,0,0,0-.4.009.8.8,0,0,0-.765.832.8.8,0,0,0,.745.85,3.124,3.124,0,0,0,.51.011Z",
    transform: "translate(-9.546 -103.371)",
    fill: "#04a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20399",
    "data-name": "Path 20399",
    d: "M2586.776-191.586v-3.336h54.682v3.336Z",
    transform: "translate(-9.702 -74.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20400",
    "data-name": "Path 20400",
    d: "M2684.226,36.116h-3.532c-.87,0-1.741-.013-2.611.011a.806.806,0,0,0-.82.837.829.829,0,0,0,.766.844,3.571,3.571,0,0,0,.567.012h9.922v2.575H2654.3V37.819h19.336a2.74,2.74,0,0,0,.621-.025.8.8,0,0,0,.686-.9.787.787,0,0,0-.767-.768,4.785,4.785,0,0,0-.567-.01H2658.63c0-.793-.042-1.545.014-2.29a.977.977,0,0,1,1.018-.882c.132-.008.265,0,.4,0h22.709c1.128,0,1.456.326,1.458,1.447C2684.228,34.934,2684.226,35.481,2684.226,36.116Z",
    transform: "translate(-66.998 -268.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20401",
    "data-name": "Path 20401",
    d: "M2587.336-261.56a2.57,2.57,0,0,1,1.758-1.792q4.9-1.7,9.8-3.4c3.641-1.263,7.291-2.5,10.92-3.795a13.811,13.811,0,0,1,9.446-.049q10.3,3.581,20.61,7.159a2.775,2.775,0,0,1,1.988,1.881c-.427,0-.813-.027-1.195,0a19.062,19.062,0,0,1-7.658-1.162c-5.072-1.688-10.2-3.219-15.3-4.809a10.358,10.358,0,0,0-6.359.05c-6.178,1.953-12.368,3.871-18.553,5.8a1.936,1.936,0,0,1-.552.111C2590.628-261.556,2589.02-261.56,2587.336-261.56Z",
    transform: "translate(-10.177 -9.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20402",
    "data-name": "Path 20402",
    d: "M2718.823-91.3h4.76c0,.406-.008.78,0,1.153.016.658.347,1.052.863,1.042.5-.01.812-.387.837-1.014.05-1.217.05-1.217,1.277-1.217h3.462c0,.49,0,.919,0,1.348,0,1.346.49,1.871,1.84,2a2.078,2.078,0,0,1,.237.051v13.691H2730v-.582c0-2.157.018-4.314-.009-6.47a5.556,5.556,0,0,0-4.612-5.4A5.523,5.523,0,0,0,2719.176-83a6.705,6.705,0,0,0-.3,1.947c-.036,2.118-.014,4.238-.014,6.357v.432h-2.088V-87.905c.026-.02.054-.061.083-.062,1.634-.045,2.044-.97,1.965-2.235C2718.8-90.556,2718.823-90.912,2718.823-91.3Z",
    transform: "translate(-120.018 -162.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20403",
    "data-name": "Path 20403",
    d: "M2869.035-69.124h-5.576V-87.67c.031-.021.058-.056.089-.059,1.515-.169,1.928-.628,1.929-2.148,0-.377,0-.754,0-1.174h3.558Z",
    transform: "translate(-244.488 -162.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20404",
    "data-name": "Path 20404",
    d: "M2634.472-91.132h3.539v1.126c0,1.607.385,2.04,2.02,2.223V-69.2h-5.559Z",
    transform: "translate(-50.175 -162.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20405",
    "data-name": "Path 20405",
    d: "M2693.338-233.043h-32.259l-.029-.1c.4-.127.8-.255,1.2-.381q6.221-1.943,12.442-3.884a8.048,8.048,0,0,1,4.861-.016c4.458,1.377,8.909,2.778,13.362,4.173A3.9,3.9,0,0,1,2693.338-233.043Z",
    transform: "translate(-72.729 -38.301)",
    fill: "#0499bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20406",
    "data-name": "Path 20406",
    d: "M2682.937-55.172V-68.918h3.341v13.746Z",
    transform: "translate(-91.301 -181.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20407",
    "data-name": "Path 20407",
    d: "M2829.579-55.187v-13.77h3.353v13.77Z",
    transform: "translate(-215.738 -181.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20408",
    "data-name": "Path 20408",
    d: "M2744.736-38.6h-2.921a2.918,2.918,0,0,1-.05-.377c0-2.23-.032-4.46.01-6.689a3.722,3.722,0,0,1,2.328-3.464,5.539,5.539,0,0,1,.633-.209Z",
    transform: "translate(-141.211 -198.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20409",
    "data-name": "Path 20409",
    d: "M2773.186-38.192V-48.83a3.617,3.617,0,0,1,2.85,2.679,2.543,2.543,0,0,1,.112.612c.008,2.435,0,4.871,0,7.347Z",
    transform: "translate(-167.885 -198.645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20410",
    "data-name": "Path 20410",
    d: "M2595.339,67.983H2586.9V65.422h8.436Z",
    transform: "translate(-9.81 -295.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20411",
    "data-name": "Path 20411",
    d: "M2900.561,67.942h-8.445V65.389h8.445Z",
    transform: "translate(-268.806 -295.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20412",
    "data-name": "Path 20412",
    d: "M2676.771-91.109v1.565h-7.5v-1.565Z",
    transform: "translate(-79.707 -162.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20413",
    "data-name": "Path 20413",
    d: "M2823.283-91.072v1.558h-7.512v-1.558Z",
    transform: "translate(-204.022 -162.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20414",
    "data-name": "Path 20414",
    d: "M2586.831-91.1h5.421v1.568h-5.421Z",
    transform: "translate(-9.748 -162.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20415",
    "data-name": "Path 20415",
    d: "M2912.047-89.549v-1.559h5.42v1.559Z",
    transform: "translate(-285.719 -162.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20416",
    "data-name": "Path 20416",
    d: "M2720.624-146.836h-7.035a3.123,3.123,0,0,1-.51-.011.8.8,0,0,1-.745-.85.8.8,0,0,1,.766-.832,2.706,2.706,0,0,1,.4-.009h14.354a3.344,3.344,0,0,1,.34.006.84.84,0,0,1,.809.856.842.842,0,0,1-.829.837c-.15.013-.3,0-.454,0Z",
    transform: "translate(-116.247 -114.032)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBangaluru);
export default __webpack_public_path__ + "static/media/bangaluru.ea6b9715ea5d45afa37ebb8b8685a542.svg";
export { ForwardRef as ReactComponent };